"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying the Loading Dots
 * @param {Object} props React props object
 */
const LoadingDots = ({
  className,
  color,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLoadingDots, {
  role: "presentation",
  "aria-busy": true,
  className: className ? `rui-loading-dots ${className}` : 'rui-loading-dots',
  ...otherProps,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LoadingDotsWrapper, {
    role: "list",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dot1, {
      role: "listitem",
      color: color,
      className: "rui-loading-dots__dot"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dot2, {
      role: "listitem",
      color: color,
      className: "rui-loading-dots__dot"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dot3, {
      role: "listitem",
      color: color,
      className: "rui-loading-dots__dot"
    })]
  })
});

LoadingDots.propTypes = {
  color: _propTypes.default.string
};
LoadingDots.defaultProps = {
  color: undefined
};
LoadingDots.displayName = 'LoadingDots';
var _default = LoadingDots;
exports.default = _default;